import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDependenciesConfigurationItem } from '../../../../reducers/documentation/documentationReducer';
import { useExpandedMode } from '../../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { DependenciesSideDialog } from '../../dependencies/DependenciesSideDialog';
import { useDependencies } from '../../dependencies/hooks/useDependencies';
import { useGetConfigurationItem } from '../../dependencies/hooks/useGetConfigurationItem';
import { LayoutDependenciesPanelProps } from './types';

export const BaseDependenciesLogic = ({
  crmOrgId,
  onCloseDocumentationDialog,
}: {
  crmOrgId: string;
  onCloseDocumentationDialog?: () => void;
}) => {
  const { handleCloseDependencies } = useDependencies(crmOrgId);

  const dependenciesData = useSelector(selectDependenciesConfigurationItem);
  const configurationItem = useGetConfigurationItem({ crmOrgId });
  const { isExpandedMode } = useExpandedMode();

  useEffect(() => {
    //clean up dependencies dialog on unmount
    return () => {
      handleCloseDependencies();
    };
  }, [handleCloseDependencies]);

  const dependenciesPanelData: LayoutDependenciesPanelProps | undefined =
    configurationItem && dependenciesData?.parentType
      ? {
          configurationItem: configurationItem || {},
          type: dependenciesData?.parentType,
        }
      : undefined;

  return (
    <>
      {dependenciesPanelData?.configurationItem && (
        <DependenciesSideDialog
          {...dependenciesPanelData}
          crmOrgId={crmOrgId}
          staticView={!!isExpandedMode}
          onCloseDocumentationDialog={onCloseDocumentationDialog}
        />
      )}
    </>
  );
};
